<template>
  <TableCell v-model:showingPopover="showingPopover" :style="cellStyle"
    :tag
    :popoverTitle
    :selectedCells
  >
    <div v-html="highAlarmString"></div>
    <div v-html="lowAlarmString"></div>
    <template #PopoverContentDesktop>
      <div style="display: flex; flex-direction: column; gap: 10px; align-items: center;">
        <div style="display: flex; align-items: flex-end; align-self: stretch;">
          <h3 style="margin-bottom: 5px;">
            {{ popoverTitle }}
          </h3>
          <div style="flex-grow: 1;"></div>
          <Button text severity="secondary" style="margin-left: 10px; margin-right: -10px; color: gray; border: 0;" @click="showingPopover = false">
            <i class="pi pi-times"></i>
          </Button>
        </div>
        <SingleColumnTable
          :session="tag.$session"
          :tableData="settingsTable"
          :selectedCells
        ></SingleColumnTable>
      </div>
    </template>
  </TableCell>
</template>

<script setup>
import { computed } from "vue";
import { createValueAndUnitHtml } from "./units.js";
import TableCell from "./TableCell.vue";
import SingleColumnTable from "./SingleColumnTable.vue";

let props = defineProps([
  "row",
  "tag",
  "showingPopover",
  "popoverTitle",
  "selectedCells",
  "targetAlarm",
]);

let showingPopover = defineModel("showingPopover");

let popoverTitle = computed(() => {
  return props.row.rowName.split("|").join(" ");
});

let cellStyle = computed(() => {
  let alarmTripped = (
    props.tag.highAlarm.tripped.value ||
    props.tag.lowAlarm.tripped.value ||
    props.tag.commErrorAlarmTripped.value ||
    props.tag.rangeErrorAlarmTripped.value
  );
  let backgroundColor = alarmTripped ? "var(--red-100)" : "";
  return { backgroundColor };
});

let unit = computed(() => {
  let tag = props.tag;
  let system = tag.$session.system;
  let sensorType = system.sensorTypes.value[tag.sensorType.value];
  return sensorType.unit;
});

let highAlarmString = computed(() => {
  let highAlarm = props.tag.highAlarm;
  if (!highAlarm.enabled.value)
    return "Disabled";
  else
    return createValueAndUnitHtml(highAlarm.$value(), unit.value, highAlarm.$precision());
});

let lowAlarmString = computed(() => {
  let lowAlarm = props.tag.lowAlarm;
  if (!lowAlarm.enabled.value)
    return "Disabled";
  else
    return createValueAndUnitHtml(lowAlarm.$value(), unit.value, lowAlarm.$precision());
});

let settingsTable = computed(() => {
  let alarmRows = [
    { id: "high", rowName: "High alarm", tag: props.tag.highAlarm },
    { id: "low", rowName: "Low alarm", tag: props.tag.lowAlarm },
    { id: "commError", rowName: "Comm error", tag: props.tag.commErrorAlarmTripped, condition: props.tag.commErrorAlarmTripped.value },
    { id: "rangeError", rowName: "Range error", tag: props.tag.rangeErrorAlarmTripped, condition: props.tag.rangeErrorAlarmTripped.value }
  ];
  alarmRows = alarmRows.filter(row => row.condition ?? true);
  
  return {
    tableName: "",
    columns: [{ tag: props.tag, name: "", subColumns: [] }],
    rows: [
      ... alarmRows.map(rowData => ({
        id: rowData.id,
        rowName: rowData.rowName,
        cells: [{
          componentType: "AggregateAlarm",
          componentArgs: {
            tag: rowData.tag,
            unit: unit.value,
            popoverTitle: rowData.rowName
          }
        }]
      })),
      {
        id: "current",
        rowName: "Current value",
        cells: [{
          componentType: "BasicStatus",
          componentArgs: {
            tag: props.tag,
            unit: unit.value,
            popoverTitle: "",
            selectedCells: props.selectedCells,
          }
        }]
      }
    ]
  };
});
</script>